"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertDatePickerParamsToStrings = void 0;
var _addDays = _interopRequireDefault(require("date-fns/addDays"));
var _date = require("../../utils/date");
var convertDatePickerParamsToStrings = exports.convertDatePickerParamsToStrings = function convertDatePickerParamsToStrings(_ref) {
  var leftValue = _ref.leftValue,
    rightValue = _ref.rightValue,
    shift = _ref.shift;
  var leftDateString = convertDatesToStringWithEllipsis(leftValue, shift);
  var rightDateString = convertDatesToStringWithEllipsis(rightValue, shift);
  return {
    left: leftDateString,
    right: rightDateString
  };
};
var convertDatesToStringWithEllipsis = function convertDatesToStringWithEllipsis(dateCell, shift) {
  var isShort = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (!(dateCell !== null && dateCell !== void 0 && dateCell.date)) return '';
  var date = dateCell.date;
  if (shift === 0) {
    var formatToken = isShort ? 'd MMM' : 'd MMMM';
    return (0, _date.formatDate)(date, formatToken);
  }
  var separator = isShort ? '...' : ' ... ';
  return "".concat((0, _date.formatDate)((0, _addDays["default"])(date, -shift), 'd MMM')).concat(separator).concat((0, _date.formatDate)((0, _addDays["default"])(date, shift), 'd MMM'));
};